export default "__VITE_ASSET__7Mr1Okg___"